__turbopack_context__.v({
  "currentBrandNode": "style-module-scss-module__8j9BKa__currentBrandNode",
  "newBrandNode": "style-module-scss-module__8j9BKa__newBrandNode",
  "wrapper": "style-module-scss-module__8j9BKa__wrapper",
});
